import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { CodeBench, CodeBenchv2 } from '@codametrix/shared-views';
import { ServiceDesk } from './service-desk';
import { useSelector, useDispatch } from 'react-redux';
import { uiActions, Utils, codeBenchActions, commonEnums } from '@codametrix/ui-common';
import { setBackToWorklistPath } from '../../actions/ui';
const ServiceDeskAndCodeBench = (props)=>{
    const { params = {} } = props.match ?? {};
    const hasId = params.id !== undefined;
    const { UIView } = useSelector((state)=>{
        return state.ampUI;
    });
    const dispatch = useDispatch();
    const childRef = useRef(null);
    const detailProps = {
        UIView,
        ...props.detailProps,
        ...props.detailMethods
    };
    const listProps = {
        ...props.listProps,
        ...props.listMethods
    };
    const [isDetailOpen, setIsDetailOpen] = useState(hasId);
    useEffect(()=>{
        if (!hasId && childRef?.current?.refreshContent) {
            childRef.current.refreshContent();
        }
        setIsDetailOpen(hasId);
    }, [
        params.id,
        hasId
    ]);
    useEffect(()=>{
        const segments = window.location.pathname.split('/').filter(Boolean);
        const basePath = `${segments[1] ?? 'worklist'}/`;
        dispatch(setBackToWorklistPath({
            path: basePath
        }));
        dispatch(uiActions.setAmplifyView());
        dispatch(uiActions.setStandaloneMode());
        dispatch(codeBenchActions.setBenchMode(commonEnums.BenchMode.CODE));
        return ()=>{
            dispatch(uiActions.setAutomateView());
        };
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                style: {
                    display: isDetailOpen ? 'none' : 'block'
                },
                children: /*#__PURE__*/ _jsx(ServiceDesk, {
                    ...listProps,
                    childRef: childRef
                })
            }),
            isDetailOpen && params.id ? Utils.doesPathEndWithV2() ? /*#__PURE__*/ _jsx(CodeBenchv2, {
                ...detailProps,
                match: props.match
            }) : /*#__PURE__*/ _jsx(CodeBench, {
                ...detailProps,
                match: props.match
            }) : null
        ]
    });
};
export { ServiceDeskAndCodeBench };
